import { deserialzeQueryStringToObject } from "GlobalUtils/Common";

export const getQueryParams = queryString => {
  const queryObj = deserialzeQueryStringToObject(queryString);
  return {
    showOfferUpfront: queryObj.showOfferUpfront === "true",
  };
};
